import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, H3, Image, Markdown } from '@honda-canada/design-system-react';
import React from 'react';
import { stripMarkdownHeading, styledCompiler } from '../../utils/markdown';
import RoutableSitecoreLink from '../RoutableSitecoreLink';
import themeStyles from './styles/NoOfferErrorCard.styles';
const Container = themeStyles.apply(Box, 'Container');
const LeftColumn = themeStyles.apply(Box, 'LeftColumn');
const RightColumn = themeStyles.apply(Box, 'RightColumn');
const CtaWrapper = themeStyles.apply(Box, 'CtaWrapper');
const NoOfferErrorCard = (props) => {
    if (!props)
        return null;
    const { title, bodyText, image, ctas } = props;
    const ctaButtons = ctas.map(({ ctaType, link }) => (_jsx(Button, { as: RoutableSitecoreLink, styling: ctaType, field: { value: link }, "data-testid": "cy-no-offer-error-card-cta" }, link.id)));
    const { src, alt } = image;
    return (_jsxs(Container, { "data-testid": "cy-no-offer-error-card", children: [_jsx(LeftColumn, { children: _jsx(Image, { src: src, alt: alt, objectFit: "contain", objectPosition: "center", "data-testid": "cy-no-offer-error-card-image" }) }), _jsxs(RightColumn, { children: [_jsx(H3, { mb: "m", "data-testid": "cy-no-offer-error-card-title", children: styledCompiler(stripMarkdownHeading(title)) }), _jsx(Markdown, { mb: "24px", "data-testid": "cy-no-offer-error-card-description", children: bodyText }), _jsx(CtaWrapper, { children: ctaButtons })] })] }));
};
export default NoOfferErrorCard;
